var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row required-documents"},_vm._l((_vm.data),function(item,index){return _c('div',{key:index,staticClass:"col-12 display-webkit-inline"},[_vm._m(0,true),_c('p',{domProps:{"innerHTML":_vm._s(item.title)}}),_c('br')])}),0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"circle"},[_c('span',{staticClass:"icon-arrow_forward_ios"})])
}]

export { render, staticRenderFns }